import { render } from "./ValidateTextarea.vue?vue&type=template&id=67a5c546&scoped=true"
import script from "./ValidateTextarea.vue?vue&type=script&lang=js"
export * from "./ValidateTextarea.vue?vue&type=script&lang=js"

import "./ValidateTextarea.vue?vue&type=style&index=0&id=67a5c546&lang=scss&scoped=true"

import exportComponent from "../../../../../DIARC/texnoelm/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a5c546"]])

export default __exports__